import { ATTACHMENTS, ENDPOINTS } from 'newJs/config';
import { doAjax } from 'newJs/utils';

const { CLICK_ACTIONS: ACTIONS } = ATTACHMENTS;
const {
    DOWNLOAD_ALL,
    DOWNLOAD,
    SAVE_TO_CONTACTS,
    SAVE_TO_FILES_ALL,
    SAVE_TO_FILES,
    SAVE_TO_FOTO
} = ACTIONS;

const prepareSave = (MAPI, apiHost) => {
    const getApiUrl = (target) => {
        const hostName = target === 'contacts' ? MAPI.v2.contactsSave() : apiHost[target];
        const endPoint = target === 'contacts' ? '' : ENDPOINTS[`SAVE_TO_${target.toUpperCase()}`];

        return hostName + endPoint;
    };

    const prepareData = (data) => Array.isArray(data)
        ? data.map((item) => ({ url: MAPI.baseUrl + item.href, filename: item.name }))
        : [{ url: MAPI.baseUrl + data.href, filename: data.name }];

    return (target, data) => doAjax({
        url: getApiUrl(target),
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({ urls: prepareData(data) })
    });
};

export default ({ apiHost, currentFolder, MAPI, msgUID }) => {
    const saveTo = prepareSave(MAPI, apiHost);

    const doAction = {
        [DOWNLOAD](item) {
            location.href = MAPI.baseUrl + item.href;
        },
        [DOWNLOAD_ALL](/* item */) {
            window.open(MAPI.v2.getAllAsZip(currentFolder, msgUID), '_blank');
        },
        [SAVE_TO_CONTACTS](item) {
            return saveTo('contacts', item);
        },
        [SAVE_TO_FILES](item) {
            return saveTo('files', item);
        },
        [SAVE_TO_FILES_ALL](items) {
            return saveTo('files', items);
        },
        [SAVE_TO_FOTO](item) {
            return saveTo('foto', item);
        }
    };

    return (actionName, itemData) => {
        // console.log('target: %s', actionName);
        const name = Object.prototype.hasOwnProperty.call(doAction, actionName)
            ? actionName
            : DOWNLOAD;

        return doAction[name](itemData);
    };
};
